/**
 * 负责网络请求
 */
import {getV3, Header} from '@/common/js/http/v3http'
import Util, { mergeOption } from '../../util/index.js';
import qs from 'qs'
let OpenAPI = {
  /**
   * 设置signAPI的userId和userToken
   */
  setUserToken({ userId, userToken }) {
    Util.isString(userId) && (this.userId = userId);
    Util.isString(userToken) && (this.userToken = userToken);
  },

  // # 新华500收益指数-成分股排行
  // 成份股排序，按涨跌幅降序
  blockSort({ code, fields }) {
    // return openAxios.get('/quote/v1/block/sort?prod_code=' + code + '&sort_field_name=px_change_rate' + '&fields=' + fields);
    let obj = {
      prod_code: code,
      sort_field_name: 'px_change_rate',
      fields: fields
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/stock_sort', obj)
    // return openAxios.get('/cnfinance/xinhua500/stock_sort?prod_code=' + code + '&sort_field_name=px_change_rate' + '&fields=' + fields);
  },

  // # 新华500收益指数-成交明细
  tick({ code, fields, dataCount, start_pos, business_type, search_direction }) {
    search_direction = search_direction || 1
    let start_str = ''
    start_pos && (start_str = '&start_pos=' + start_pos)
    let busi_str = ''
    business_type && (busi_str = '&business_type=' + business_type)
    fields = fields || 'hq_px,business_amount,business_direction';
    dataCount = dataCount || 20;
    let obj = {
      prod_code: code,
      fields: fields,
      data_count: dataCount + start_str + busi_str,
      search_direction: search_direction
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/stock_deal', obj)
    // return openAxios.get('/cnfinance/xinhua500/stock_deal?prod_code=' + code + '&fields=' + fields + '&data_count=' + dataCount + start_str + busi_str + '&search_direction=' + search_direction);
    // return openAxios.get("/quote/v1" + '/tick?prod_code=' + code + '&fields=' + fields +'&data_count=' + dataCount + start_str + busi_str +'&search_direction='+search_direction);
  },
  // # 新华500收益指数-K线图
  kline(params) {
    if (window.location.hash == "#/Finance/Xinhua500Index") {
      if (params.fields == "close_px") {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '99%'
      } else {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '53vh'
        document.getElementsByClassName('quote-graph-component')[1].style.height = '16vh'
        document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '-15px'
      }
    } else if (window.location.hash == "#/ChinaInformationV2/1" || window.location.hash == "#/ChinaInformationV2/:id") {
      if (params.fields == "close_px") {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '40vh'
      } else {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '19vh'
        document.getElementsByClassName('quote-graph-component')[1].style.height = '19vh'
        document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '0px'
      }
    } else {
      if (params.fields == "close_px") {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '40vh'
      } else {
        document.getElementsByClassName('quote-graph-component')[0].style.height = '24vh'
        document.getElementsByClassName('quote-graph-component')[1].style.height = '19vh'
        document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '0px'
      }
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/k_line', params)
    // return openAxios.get('/cnfinance/xinhua500/k_line', { params })
    // return openAxios.get("/quote/v1" + '/kline', { params });
  },

  // # 新华500收益指数-分时
  trend({ code, dataType, fields, crc, minTime }) {
    fields = fields || 'last_px,business_amount,business_balance,avg_px,index_rise_trend,index_fall_trend';
    dataType = dataType || 'trend';
    function timeFormat(){
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()+1;
      var day = date.getDate();
      if (month < 10){
        month = "0" + month
      }
      if (day < 10) {
        day = "0" + day
      }
      var nowDate = year+month+day;
      return nowDate;
    }
    crc = timeFormat()
    let obj = {
      prod_code: code,
      fields,
      crc,
      min_time: minTime,
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/min_time', obj)
    // return openAxios.get("/cnfinance/xinhua500/min_time", {
    //   params: {
    //     prod_code: code,
    //     fields,
    //     crc,
    //     min_time: minTime,
    //   }
    // });

    // return openAxios.get("/quote/v1" + '/' + dataType, {
    //   params: {
    //     prod_code: code,
    //     fields,
    //     crc,
    //     min_time: minTime,
    //   }
    // });    
  },

  // # 新华500收益指数-指数比较
  mintime5({ code, fields }) {
    if (window.location.hash == "#/Finance/Xinhua500Index") { 
      document.getElementsByClassName('quote-graph-component')[0].style.height = '99%'
    } else {
      document.getElementsByClassName('quote-graph-component')[0].style.height = '40vh'
    }
    fields = 'last_px,business_amount,business_balance,avg_px,index_rise_trend,index_fall_trend';
    // return openAxios.get("/quote/v1" + '/real?en_prod_code=' + code + '&fields=' + fields);
    let obj = {
      prod_code: code,
      fields: fields
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/min_time_5', obj)
    // return openAxios.get('/cnfinance/xinhua500/min_time_5?prod_code=' + code + '&fields=' + fields)
  },

  // # 新华500收益指数-指数比较
  real({ code, fields }) {
    fields = fields || 'open_px,high_px,low_px,last_px,business_amount,business_balance,shares_per_hand';
    // return openAxios.get("/quote/v1" + '/real?en_prod_code=' + code + '&fields=' + fields);
    let obj = {
      en_prod_code: code,
      fields: fields
    }
    return getV3(Header.cnfinance +'/cnfinance/xinhua500/stock_index', obj)
    // return getV3('/cnfinance/xinhua500/stock_index?en_prod_code=' + code + '&fields=' + fields)
  },
}
const CommonAPI = {
}
export {
  OpenAPI,
  CommonAPI
}
